export const forms = {
    addNewsForm: 'addNewsForm',
    updateNewsForm: 'updateNewsForm',
};

export const newsFields = {
    title: 'title',
    body: 'body',
    tags: 'tags',
    youtubeLink: 'youtubeLink',
};

export const requiredFields = [newsFields.title];
export const localizableFields = [newsFields.title, newsFields.body];

export const defaultValues = {
    tags: [],
    images: [],
    youtubeLink: '',
    isListed: true,
};

// Add validation pattern for YouTube URLs
// TODO: add link with timestamp at the end
export const patterns = {
    youtubeLink: /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})$/,
};
